module.exports = __webpack_public_path__ + "static/media/tickIcon.deee051b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/universal/images/tickIcon.svg
// module id = 995
// module chunks = 0